module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-03.f03d60fc.png";